import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import IndexedDBClassificationRepository from "../Classifications/IndexedDBClassificationRepository";

export default class IndexedDBTagRepository extends IndexedDBClassificationRepository {
    public readonly source: InternalIndexedDBDatabase["tags"];
    protected readonly dataTypeName = "Tag";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.tags;
    }
}
